import React from 'react';
import { ChevronRight } from '@/components/Icons/ChevronRight';
import { tv } from '@/utils/tv';

const card = tv({
  base: 'flex h-16 w-full cursor-pointer items-center gap-2 rounded-xl px-4 text-left transition-colors',
  variants: {
    isSelected: {
      true: 'bg-info-surface contrast:border contrast:border-primary',
      false: 'hover:bg-hover',
    },
  },
});

const title = tv({
  base: 'text-subhead-14 truncate',
  variants: {
    isSelected: {
      true: 'text-primary',
      false: 'text-foreground',
    },
  },
});

const subtitle = tv({
  base: 'text-caption-12 truncate',
  variants: {
    isSelected: {
      true: 'text-primary',
      false: 'text-muted-foreground',
    },
  },
});

interface Props {
  name: string;
  teachers: string;
  isSelected: boolean;
  onSelect: () => void;
}

export const JournalCard: React.FC<Props> = ({
  name,
  teachers,
  isSelected,
  onSelect,
}) => (
  <button type="button" onClick={onSelect} className={card({ isSelected })}>
    <span className="flex min-w-0 flex-1 flex-col">
      <span className={title({ isSelected })}>{name}</span>
      {!!teachers && (
        <span className={subtitle({ isSelected })}>{teachers}</span>
      )}
    </span>
    <ChevronRight
      className={`size-4 shrink-0 ${isSelected ? 'text-primary' : 'text-muted-foreground'}`}
    />
  </button>
);
